import { render, staticRenderFns } from "./param-selector.vue?vue&type=template&id=8c4eb89a&"
import script from "./param-selector.vue?vue&type=script&lang=js&"
export * from "./param-selector.vue?vue&type=script&lang=js&"
import style0 from "./param-selector.vue?vue&type=style&index=0&id=8c4eb89a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports